// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { CustomerRegistrationResponseFragmentDoc } from '../auth/fragments/customerRegistrationResponse.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireCompleteNewCustomerDocument = gql`
    mutation questionnaireCompleteNewCustomer($input: QuestionnaireCompleteInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  questionnaireCompleteNewCustomer(input: $input, customer: $customer) {
    __typename
    customer {
      ...customerRegistrationResponse
    }
  }
}
    ${CustomerRegistrationResponseFragmentDoc}`;

export function useQuestionnaireCompleteNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.QuestionnaireCompleteNewCustomerMutation, SchemaTypes.QuestionnaireCompleteNewCustomerMutationVariables>(QuestionnaireCompleteNewCustomerDocument);
};